@if (!isLoginRoute) {
<mat-toolbar style="z-index: 1000; position: sticky;" [style.background]="toolbarGradient" [style.color]="toolbarForegroundColor">

  @if (_globals.isLoggedIn) {
    <button
      type="button"
      aria-label="Toggle sidenav"
      mat-icon-button
      (click)="toggledrawer()">
      <mat-icon aria-label="Side nav toggle icon" [style.color]="toolbarForegroundColor">menu</mat-icon>
    </button>
  }
  <!-- <img src="/assets/logos/ds_vit.svg" style="height: 24px;" />
  <img src="/assets/logos/ds_svart.svg" style="height: 24px;" *ngIf="false && this._globals.theme=='light'"/> -->

  @if (_globals.isLoggedIn) {
    <img  [src]="this.OrgImage" style="height: 40px; padding: 5px;"/>
  }@else{
    
            <img src="/assets/logos/ds_liggande_vit.svg" style="height: 24px; margin-left: 5px;" />
    
  }
  

  @if (!_globals.isLoggedIn) {
    
    <span>SCOUT</span>
  }

  @if (_globals.isLoggedIn) {
    <button mat-button routerLink="/home" (click)="onNavClick()" class="material-icons-outlined" aria-label="Home dashboard" class="nav-btn">
      <mat-icon [style.color]="toolbarForegroundColor" class="material-icons-outlined" >home</mat-icon>
      <span class="nav-label" [style.color]="toolbarForegroundColor">{{'NAVBAR.HOME' | translate}}</span>
    </button>
    <button mat-button routerLink="/games3" (click)="onNavClick()" class="nav-btn">
      <mat-icon [style.color]="toolbarForegroundColor" class="material-icons-outlined">sports_hockey</mat-icon>
      <span class="nav-label" [style.color]="toolbarForegroundColor">{{'NAVBAR.GAMES' | translate}}</span>
    </button>
    <button mat-button routerLink="/scouting" class="nav-btn">
      <mat-icon [style.color]="toolbarForegroundColor" class="material-icons-outlined">rate_review</mat-icon>
      <span class="nav-label" [style.color]="toolbarForegroundColor">{{'NAVBAR.REPORTS' | translate}}</span>
    </button>
    <button mat-button routerLink="/schedule" (click)="onNavClick()" class="nav-btn">
      <mat-icon [style.color]="toolbarForegroundColor">today</mat-icon>
      <span class="nav-label" [style.color]="toolbarForegroundColor">{{'NAVBAR.SCHEDULE' | translate}}</span>
    </button>
    <button mat-button [routerLink]="['/search']" (click)="onNavClick()" class="nav-btn">
      <mat-icon [style.color]="toolbarForegroundColor">search</mat-icon>
      <span class="nav-label" [style.color]="toolbarForegroundColor">{{'NAVBAR.SEARCH' | translate}}</span>
    </button>
    <span class="spacer"></span>
    <button mat-button routerLink="/userprofile" class="nav-btn">
      <mat-icon [style.color]="toolbarForegroundColor">account_circle</mat-icon>
      <span class="nav-label" [style.color]="toolbarForegroundColor">{{'NAVBAR.PROFILE' | translate}}</span>
    </button>
  }
  @if(_globals.isLoggedIn && false) {
      <span class="spacer"></span>
    <button mat-icon-button (click)="toggleTheme()">
      <mat-icon [style.color]="toolbarForegroundColor"><span class="material-symbols-outlined">
        format_color_fill
      </span></mat-icon>
    </button>
  }

</mat-toolbar>
}

<mat-sidenav-container class="sidenav-container"  >
  @if (_globals.isLoggedIn) {
    <mat-sidenav #drawer fixedInViewport
      class="mat-elevation-z2">
     <!--  <mat-toolbar style="height: 90px;justify-content: center; display: flex;">
        <div>
          <img  [src]="this.OrgImage" style="height: 80px;"/>
        </div>
      </mat-toolbar> -->
      <mat-nav-list>
        <a mat-list-item class="sidenav-link" routerLink="/home" (click)="onNavClick()">
          <mat-icon class="material-icons-outlined">home</mat-icon>
          <span class="sidenav-link-label">HOME</span>
        </a>
        <a mat-list-item class="sidenav-link" routerLink="/games3"  (click)="onNavClick()">
          <mat-icon>sports_hockey</mat-icon>
          <span class="sidenav-link-label">{{'NAVBAR.GAMES' | translate | uppercase}}</span>
        </a>
        <a mat-list-item class="sidenav-link" routerLink="/scouting"  (click)="onNavClick()">
          <mat-icon class="material-icons-outlined">rate_review</mat-icon>
          <span class="sidenav-link-label">{{'NAVBAR.REPORTS' | translate | uppercase}}</span>
         </a>
          <!--<a mat-list-item class="sidenav-link" routerLink="/scouting_2"  (click)="onNavClick()">
          <mat-icon>rate_review</mat-icon>
          <span class="sidenav-link-label">{{'NAVBAR.REPORTS' | translate | uppercase}}</span>
        </a> -->
        <a mat-list-item class="sidenav-link" routerLink="/schedule"  (click)="onNavClick()">
          <mat-icon class="material-icons-outlined">event</mat-icon>
          <span class="sidenav-link-label">{{'NAVBAR.SCHEDULE' | translate | uppercase}}</span>
        </a>
        <a mat-list-item class="sidenav-link" routerLink="/lists"  (click)="onNavClick()">
          <mat-icon class="material-icons-outlined">format_list_numbered</mat-icon>
          <span class="sidenav-link-label">{{'NAVBAR.RANKINGLISTS' | translate | uppercase}}</span>
        </a>

        @if (isScoutingAdmin()) {
          <mat-divider></mat-divider>
          <a mat-list-item class="sidenav-link" routerLink="/admin/settings" (click)="onNavClick()">
            <mat-icon class="material-icons-outlined">settings</mat-icon>
            <span class="sidenav-link-label">{{'GENERAL.SETTINGS' | translate | uppercase}}</span>
          </a>
        }
      </mat-nav-list>
      <mat-divider></mat-divider>
      <br/>
      
      @if (this._globals.theme=='light') {
        <img src="/assets/logos/ds_liggande_svart.svg" style="height: 24px; padding: 10px;" />
      }
      @if (this._globals.theme!='light') {
        <img src="/assets/logos/ds_liggande_vit.svg" style="height: 24px; padding: 10px;" />
      }
    </mat-sidenav>
  }
  <mat-sidenav-content style="height: 95vh;">

    <router-outlet ></router-outlet>

  </mat-sidenav-content>

</mat-sidenav-container>
